export const appConfig = {
  title: import.meta.env.VITE_APP_TITLE,

  api: {
    base: import.meta.env.VITE_API_URL ?? '/nutritionist/API',
    mealPlanner: import.meta.env.VITE_MEAL_PLANNER_API_URL ?? '/API/mealplanner',
    search: import.meta.env.VITE_SEARCH_API_URL ?? '/API/search',
  },

  keycloak: {
    url: import.meta.env.VITE_KEYCLOAK_URL,
    realm: import.meta.env.VITE_KEYCLOAK_REALM,
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    multiTenancyEnabled: import.meta.env.VITE_KEYCLOAK_MULTI_TENANT === 'true',
  },
} as const
